
import React from 'react';
import { Button } from '@/components/ui/button';
import { SecureProfilePhoto } from '@/components/profile/SecureProfilePhoto';

interface UserMenuButtonProps {
  onClick: () => void;
  profilePhotoPath: string | null;
  initials: string;
}

export const UserMenuButton: React.FC<UserMenuButtonProps> = ({
  onClick,
  profilePhotoPath,
  initials
}) => {
  return (
    <Button
      onClick={onClick}
      className="w-14 h-14 rounded-full p-0 bg-transparent hover:bg-transparent border-2 border-sports-green"
    >
      <SecureProfilePhoto
        filePath={profilePhotoPath}
        fallbackInitials={initials}
        size="md"
        className="w-full h-full border-0 rounded-full"
      />
    </Button>
  );
};
